import styled, { css } from 'styled-components';

export const FieldItem = styled.div`
  ${({ theme, active, textAlign }) => css`
    background: ${active ? theme.v2.colors.brand.primaryLowLight : theme.v2.colors.white.pure};
    border: 1px solid ${active ? theme.v2.colors.brand.primaryLowLight : theme.v2.colors.neutral.highMedium};
    border-radius: 8px;
    color: ${active ? theme.v2.colors.brand.primaryMedium : theme.v2.colors.neutral.lowMedium};
    cursor: pointer;
    display: flex;
    font-size: ${theme.v2.font.sizes.xxs};
    font-weight: ${active ? '500' : '400'};
    line-height: 1.5;
    justify-content: ${textAlign === 'center' ? 'center' : 'flex-start'};
    padding: 16px;
    width: 100%;

    @media (min-width: ${theme.v2.breakpoints.md}) {
      font-size: ${theme.v2.font.sizes.xs};
    }
  `}
`;
